<template>
  <div id="app" v-if="$route.meta != null && $route.meta.winpop == true && $route.meta.isBoard == null" class="winpop">
    <router-view :key="$route.fullPath"></router-view>
  </div>
  <div id="app" v-else-if="$route.meta != null && $route.meta.winpop == true && $route.meta.isBoard == true" class="hw_wrap">
    <router-view :key="$route.fullPath"></router-view>
  </div>
  <div id="app" v-else >
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>


// WEBPACK FOOTER //
// src/App.vue